import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../../../overlays/modal'
import { Header } from 'semantic-ui-react'
import Icon from '../../../elementals/icon'
import Button from '../../../elementals/button'
import Text from '../../../elementals/text'

const title = 'Are you sure you want to delete this photo?'

const PhotoDeleteModal = ({
  isOpen,
  photoToDelete,
  onDeleteConfirm,
  onDeleteCancel,
  subtitle = 'This photo has not been uploaded yet and therefore will not be saved as an Unused Photo. Okay to delete ?',
}) => {
  return (
    <Modal
      open={isOpen}
      closeIcon={false}
      size='small'
      data-elm-id='delete-image-modal'
    >
      <Header>
        <Header.Content>
          <Icon name='exclamation-triangle' color='caution' iconStyle='solid' />
          {title}
          <br />
          <Text className='u-mt-1' size='tiny'>
            {subtitle}
          </Text>
        </Header.Content>
      </Header>
      <Modal.Content>
        <section style={{ textAlign: 'center' }}>
          <img
            width='400'
            src={photoToDelete.photoUrl}
            style={{ borderRadius: 6 }}
          />
        </section>
      </Modal.Content>
      <Modal.Actions>
        <Button
          role='secondary'
          elmId='on-cancel-delete-button'
          onClick={onDeleteCancel}
        >
          Cancel
        </Button>
        <Button
          role='primary'
          color='error'
          elmId='on-photo-delete-button'
          onClick={onDeleteConfirm}
        >
          Yes, Delete Photo
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

PhotoDeleteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  photoToDelete: PropTypes.object.isRequired,
  onDeleteConfirm: PropTypes.func.isRequired,
  onDeleteCancel: PropTypes.func.isRequired,
  subtitle: PropTypes.string,
}

export default PhotoDeleteModal
